module.exports = __webpack_public_path__ + "img/hr-electric-mining-drill-W-patch-shadow.ec85f982.png";